import axiosInstance from "../utils/axios/axios";
import privateAxiosInstance from "../utils/axios/private";

export const proctoringApi = {
    logViolation: async (payload) => {
        try {
            const response = await privateAxiosInstance.post(
                "/api/monitoring/log/",
                payload,
                
            );
            return response.data;
        } catch (error) {
            console.error("logViolation API error:", error);
            return null;
        }
    },

    getReport: async (interview_id) => {
        try {
            const response = await privateAxiosInstance.get(
                `/api/monitoring/report/?interview_id=${interview_id}`,
                
            );
            return response.data;
        } catch (error) {
            console.error("getReport API error:", error);
            return null;
        }
    },
};